<template>
  <div>
    <div class="dorm-tab__list">
      <div
        v-for="dorm in dorms"
        :key="dorm.index"
        class="dorm-tab__col col-xl-3 col-lg-3 col-md-3"
        :class="{
          'col-xl-12 col-lg-12 col-md-12 col-sm-12':
            dorm.banners && dorm.banners.length > 0,
          empty: dorm.banners && dorm.banners.length <= 0
        }"
      >
        <room-card :dorm="dorm" v-if="!dorm.banners" />
        <div class="banner-section row" v-if="dorm.banners">
          <banner-item
            class="col-xl-6 col-lg-6 col-md-12 col-sm-12"
            v-for="banner in dorm.banners"
            :key="banner.id"
            :banner="banner"
            :to="{
              name: 'DormDetail',
              params: { slug: banner.dorm.slug, id: banner.dorm_id }
            }"
          />
        </div>
      </div>
      <empty-content :content="emptyContent" v-if="dorms.length === 0" />
    </div>
  </div>
</template>

<script>
import BannerItem from '@/components/BannerItem'
import RoomCard from '@/components/RoomCard'
export default {
  name: 'RoomList',
  props: {
    dorms: Array
  },
  components: {
    RoomCard,
    BannerItem
  },
  data() {
    return {
      emptyContent: {
        icon: 'icon-search',
        title: 'Sonuç Bulunamadı!',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      }
    }
  }
}
</script>

<style scoped></style>
